// Reporting Page State

export const reportingPageInitialState = {
  // Active tab: 'del_reports' or 'safety_reports'
  activeTab: "del_reports",

  // Selected report type from dropdown
  selectedReportType: null, // 'unit_cost', 'timesheet', 'creation_report'

  // Filter visibility and animation state
  filterSectionVisible: false,
  filterSectionAnimating: false,

  // Filters for report generation
  filters: {
    // DEL Status
    delStatus: "",
    delStatusLabel: "",

    // Date filters
    createdStartDate: "",
    createdEndDate: "",
    delStartDate: "",
    delEndDate: "",
    submitStartDate: "",
    submitEndDate: "",
    approvalStartDate: "",
    approvalEndDate: "",

    // Project/Phase
    projectNumber: "",
    projectLabel: "",
    phase: "",
    phaseLabel: "",
    projectPhaseList: [],

    // Employee filters
    projectManager: "",
    projectManagerName: "",
    invoiceManager: "",
    invoiceManagerName: "",
    createdBy: "",
    createdByName: "",
    approvedBy: "",
    approvedByName: "",

    // Special filters
    splitMonth: false, // Only for unit_cost report
    includeOverheadProjects: false, // Only for unit_cost report
    org: "",
  },

  // Task management
  currentTaskId: null,
  taskStatus: null, // 'pending', 'processing', 'completed', 'failed'
  taskError: null,

  // Phase list for selected project
  filterPhaseList: [],
};
